export default {
  common: {
    language: 'Idioma',
    logoAlt: 'Zhongze Education',
    cancel: 'Cancelar',
  },
  chatService: {
    chatNow: {
      label: 'Conversar agora',
    },
    emailGate: {
      title: 'E-mail necessário',
      desc: 'Introduza o seu e-mail para continuar o chat.',
      successMessage: 'E-mail enviado. Pode continuar a conversar.',
    },
  },
  nav: {
    home: 'Início',
    products: 'Produtos',
    software: 'Software',
    eduServices: 'Serviços Educacionais',
    support: 'Serviço e Suporte',
    cooperation: 'Cooperação Educacional',
    about: 'Sobre nós',

    // Sub-menus & Mega Menu
    learningPlatform: 'Plataforma de Aprendizagem Zhongze Education',
    cloudPlatform: 'Plataforma em Nuvem Zhongze Education',
    laserSoftware: 'Software dedicado para equipamentos a laser',
    makerK12: 'Maker Education - Ensino básico',
    archVocational: 'Modelos arquitetônicos - Ensino técnico',
    cultHigherVoc: 'Design cultural e criativo - Ensino profissional superior',
    artsUni: 'Artes e artesanato - Universidades',
    afterSales: 'Pós-venda',
    faq: 'Perguntas frequentes',
    download: 'Centro de downloads',
    companyIntro: 'Perfil da empresa',
    news: 'Notícias',
    contact: 'Fale conosco',
    device: 'Equipamentos',
    kits: 'Kits',
    softwareService: 'Serviços de software',
    accessories: 'Acessórios',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Sistema de kits',
    kitsAccessories: 'Acessórios do kit',
    courses: 'Cursos',
  },
  aboutPage: {
    seoTitle: 'Sobre nós - Zhongze Education',
    banner: {
      title: 'Sobre nós',
    },
    about: {
      title: 'Sobre nós',
      body: 'A Zhongze Education foi fundada em 2015 e, com a estreita cooperação com a China Unicom International (Hong Kong), desenvolveu de forma independente um sistema de educação maker adequado às crianças na China, com base em currículos STEAM da Europa e dos EUA. Por meio de aprendizagem social e prática, ajudamos as crianças a ultrapassar limites e criar resultados incríveis. Com “Educação STEAM + Espaço Maker” como núcleo e com a missão de “formar criadores do futuro”, focamos na educação de criatividade tecnológica para crianças e adolescentes de 3 a 16 anos. Implantamos espaços de inovação educacional, desenvolvemos produtos e cursos próprios e, em torno de módulos como software de design para aprendizagem, gravação a laser e programação, formamos um ecossistema único de P&D de conteúdo educacional e um ciclo fechado de produtos. Assim, as crianças desenvolvem competências essenciais para o futuro em projetos reais! Nossa visão é tornar-nos defensores internacionais da educação de inovação científica e tecnológica. Oferecemos não apenas cursos e ambientes maker, mas também uma nova forma de aprender. Acreditamos que cada criança é uma inovadora do futuro: pensamos e exploramos como cientistas, colocamos a mão na massa como engenheiros, criamos como designers e aprendemos e fazemos como makers. Que elas se descubram na exploração e alcancem o futuro na prática.',
    },
    intro: {
      title: 'Por que nos escolher?',
      desc: 'Como defensores internacionais da educação de inovação científica e tecnológica, oferecemos cursos e ambientes maker e, mais do que isso, uma nova forma de aprender. Acreditamos que cada criança é uma inovadora do futuro: que se descubra na exploração e alcance o futuro na prática.',
      features: {
        projectLearning:
          'Aprendizagem baseada em projetos: por meio de projetos reais, as crianças desenvolvem competências essenciais para o futuro.',
        interactiveExperiments:
          'Experimentos interativos: com esses experimentos, as crianças não só dominam princípios científicos básicos, como também desenvolvem capacidade de resolver problemas, criatividade e espírito de trabalho em equipe.',
      },
    },
    images: {
      aboutAlt: 'Sobre a Zhongze Education',
      featureIcon1Alt: 'Ícone de aprendizagem baseada em projetos',
      featureIcon2Alt: 'Ícone de experimentos interativos',
      introAlt: 'Por que nos escolher',
    },
  },
  newsPage: {
    banner: {
      title: 'Notícias',
    },
    tabs: [
      { id: 'all', name: 'Todos' },
      { id: 'company', name: 'Notícias da empresa' },
      { id: 'exhibition', name: 'Notícias de feiras' },
      { id: 'industry', name: 'Tendências do setor' },
    ],
    items: [
      {
        title:
          'Henghao Laser brilha na BETT UK 2025: tecnologia a laser impulsionando a inovação educacional',
      },
      {
        title:
          'O núcleo da inovação K-12: como os cortadores a laser CO2 impulsionam o ensino STEAM',
      },
      {
        title:
          'Clientes da Henghao Laser brilham com o Light 530 na didacta Italia 2025',
      },
      {
        title:
          'Zhongze Education lança uma nova solução de educação inteligente',
      },
      {
        title:
          'Tendências da educação do futuro: integração profunda entre IA e educação maker',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'Notícias',
    },
    tabs: [
      { id: 'all', name: 'Todos' },
      { id: 'company', name: 'Notícias da empresa' },
      { id: 'exhibition', name: 'Notícias de feiras' },
      { id: 'industry', name: 'Tendências do setor' },
    ],
    items: [
      {
        title:
          'Zhongze Technology lança kits de robótica educacional de nova geração, liderando a nova tendência do ensino STEM',
      },
      {
        title:
          'IA nas escolas: como a educação em programação melhora o raciocínio lógico dos alunos',
      },
      {
        title:
          'Competição Nacional de Robótica Juvenil 2023 encerra com sucesso; equipes apoiadas pela Zhongze alcançam ótimos resultados',
      },
      {
        title:
          'Explorando a educação do futuro: plano de construção de salas de aula inteligentes na era da transformação digital',
      },
      {
        title:
          'Zhongze Technology firma parcerias estratégicas com várias universidades para cofundar um laboratório conjunto de IA',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Educação maker',
        desc: 'Oferece um espaço para experimentação e exploração, promovendo o desenvolvimento integral dos alunos',
      },
      item2: {
        title: 'Abra a porta do conhecimento',
        desc: 'Da aplicação de equipamentos a laser ao aprendizado com kits e cursos, atendemos a diferentes necessidades de aprendizagem de forma completa.',
      },
      item3: {
        title: 'Kits e cursos',
        desc: 'Essencial para aumentar a eficiência em cursos de IA, ISTEAM e educação de inovação científica e tecnológica',
      },
    },
    resources: {
      title: 'Recursos ricos para o ensino de STEM',
      tabs: {
        laser: {
          name: 'Cortador a laser',
          title: 'Equipamentos a laser',
          desc1: 'Máquina inteligente de corte e gravação a laser de mesa',
          desc2:
            'Corte de alta precisão│Operação inteligente e prática│Processamento eficiente│Seguro e ecológico',
        },
        software: {
          name: 'Software',
          title: 'Software educacional',
          desc1: 'Software completo e multifuncional',
          desc2:
            'Plataforma em nuvem | Plataforma de aprendizagem | Light Maker',
        },
        ai: {
          name: 'Assistência inteligente de ensino por IA',
          title: 'Assistência inteligente de ensino',
          desc1: 'Monitoramento em tempo real e alertas de equipamentos',
          desc2: 'Assistente de IA | Painel visual',
        },
        kits: {
          name: 'Kits e cursos',
          title: 'Kits de curso completos',
          desc1: 'Aprendizagem baseada em projetos (PBL)',
          desc2: 'Materiais didáticos | Mão na massa',
        },
      },
    },
    different: {
      title: 'O que nos torna diferentes',
      items: {
        solution: {
          title: 'Soluções de IA para educação',
          desc: 'Elevar a eficácia do ensino e a experiência de aprendizagem',
        },
        course: {
          title: 'Cursos de pensamento criativo',
          desc: 'Cursos adequados para crianças e adolescentes de 3 a 16 anos',
        },
        product: {
          title: 'Produtos educacionais de inovação',
          desc: 'Criar com laser em um clique',
        },
        space: {
          title: 'Espaço maker de exploração',
          desc: 'Combina inovação e praticidade',
        },
      },
    },
    creative: {
      title: 'Criatividade em ação, criar o futuro',
      machineDesc: 'Máquina inteligente de corte e gravação a laser de mesa',
      lightBlue530Desc: 'Máquina inteligente de corte e gravação a laser azul',
      markM20Desc: 'Máquina de marcação a laser de alta precisão',
      light640Desc:
        'Máquina profissional de corte e gravação a laser de secretária',
    },
    innovation: {
      title: 'Como promover a aprendizagem inovadora?',
      desc: 'A Zhongze Education dedica-se ao desenvolvimento de produtos educacionais de alta qualidade para inovação, incluindo cortadores a laser. Esses produtos apoiam os alunos em aprendizagens práticas nas áreas de ciência, tecnologia, engenharia, artes e matemática.',
      items: {
        steam: 'STEAM',
        coding: 'Programação',
        light530: 'Usar o Light 530',
        robotics: 'Robótica',
      },
    },
    bottomBanner: {
      title: 'Levar a educação com IA para a prática',
      subtitle: 'IA + educação com inteligência digital, integrando a inovação',
      desc: 'Foco em produtos a laser personalizados e serviços técnicos, apoiando escolas e empresas na integração de “IA + educação”',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Software dedicado para equipamentos a laser  Light Maker',
      bannerDesc:
        'Software profissional para equipamentos a laser: simples e eficiente, focado na experiência de corte e gravação.',
      bannerImageAlt: 'Interface do Light Maker',
      creationTitle: 'Torne a criação mais simples',
      features: {
        proDesignTool: 'Ferramentas de design profissionais',
        highPrecisionParams: 'Configuração de parâmetros de alta precisão',
        multiDeviceControl: 'Gestão e controle de múltiplos dispositivos',
        assetLibrary: 'Sistema robusto de gestão de biblioteca de materiais',
      },
      intro: {
        imageAlt: 'Demonstração de funcionalidades',
        items: {
          item1: {
            title: 'Sistema de design poderoso e fácil de usar',
            desc: 'Software de criação robusto, compatível com designs de alta qualidade nos formatos JPG, DXF, AI, DST, PNG, BMP, TIF e SVG.',
          },
          item2: {
            title: 'Profissionalismo',
            desc: 'Funções profissionais de desenho para atender a todas as necessidades de produção. Seja um design complexo ou um corte simples, tudo é feito com facilidade.',
          },
        },
      },
      downloadTitle: 'Download do software',
      downloadButton: 'Baixar e experimentar',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Plataforma de Aprendizagem Zhongze Education',
      bannerDescLine1:
        'A Plataforma de Aprendizagem Zhongze Education é uma ferramenta inovadora de aprendizagem online, projetada para oferecer a alunos e professores uma solução completa de software educacional.',
      bannerDescLine2:
        'Em dispositivos móveis ou computadores, os usuários podem acessar e usar nossa plataforma com facilidade.',
      bannerImageAlt:
        'Interface da Plataforma de Aprendizagem Zhongze Education',
      exploreTitle:
        'Explore possibilidades infinitas e crie um futuro brilhante',
      exploreTabs: [
        { name: 'Criar' },
        { name: 'Primeiros passos' },
        { name: 'Aprender modelagem' },
        { name: 'Criação com um clique' },
        { name: 'Gerar imagem com IA' },
      ],
      tabContentAlt: 'Demonstração de funcionalidades',
      introTitle: 'Plataforma de aprendizagem inovadora',
      introItems: [
        {
          title: 'Nova experiência de aprendizagem eficiente',
          desc: 'A Plataforma de Aprendizagem Zhongze Education integra, em um só lugar, o estudo de cursos, o design gráfico e o corte a laser. A interface em cartões é simples e intuitiva, com operação fluida, conectando de forma contínua o design criativo à produção física — eficiente e fácil de usar.',
        },
        {
          title: 'Inteligente e prática, perfeita para iniciantes',
          desc: 'Com uma ampla biblioteca integrada e presets inteligentes de parâmetros, é possível criar com um clique e começar em segundos. No celular, tutoriais guiados detalhados eliminam a dificuldade de entrada. Na nuvem, o monitoramento em tempo real do status dos equipamentos protege a segurança do ensino durante todo o processo.',
        },
      ],
      introImageAlt: 'Plataforma de aprendizagem inovadora',
      galleryAlt: 'Demonstração da plataforma',
      downloadTitle: 'Download do software',
      downloadApps: [
        { name: 'App da Plataforma Zhongze Education' },
        { name: 'Software de design Zhongze (PC)' },
      ],
      downloadButtonText: 'Baixar e experimentar',
    },
    cloudPlatform: {
      bannerTitle: 'Plataforma em Nuvem Zhongze Education',
      bannerDesc:
        'Ferramenta integrada de gestão educacional: suporta envio e recebimento de tarefas, monitoramento de equipamentos, solicitações de manutenção e configuração de parâmetros, ajudando professores, alunos e escolas a gerenciar com eficiência.',
      bannerImageAlt: 'Interface da Plataforma em Nuvem Zhongze Education',
      exploreTitle: 'Simplifique a gestão do ensino',
      exploreTabs: [
        { name: 'Criar' },
        { name: 'Primeiros passos' },
        { name: 'Aprendizagem avançada' },
      ],
      tabContentAlt: 'Demonstração de funcionalidades',
      introTitle: 'Aumente a eficiência educacional',
      introItems: [
        {
          title: 'Operação conveniente',
          desc: 'Criação com um clique: biblioteca e parâmetros integrados, simplificando o fluxo de operação. Monitoramento de equipamentos: acompanhe o status em tempo real para garantir o bom andamento das atividades de ensino.',
        },
        {
          title: 'Gestão unificada',
          desc: 'Interligação de equipamentos: suporta a conexão de outros dispositivos da sala maker, com gestão em um clique para aumentar a eficiência.',
        },
        {
          title: 'Monitoramento em tempo real',
          desc: 'Status do equipamento: acompanhe o funcionamento em tempo real e solicite manutenção rapidamente em caso de falha. Manutenção preventiva: com base no tempo de uso e na frequência, o sistema envia lembretes periódicos para prolongar a vida útil e melhorar a qualidade de corte.',
        },
      ],
      introImageAlt: 'Plataforma de aprendizagem inovadora',
      galleryTitle: 'Levar a educação com IA para a prática',
      galleryDesc:
        'IA + educação com inteligência digital, integrando a inovação',
    },
  },
  eduServices: {
    banner: {
      title: 'IA + educação',
      desc: 'As soluções de ensino com inteligência digital da Zhongze Education apoiam a formação de talentos inovadores. Orientadas pelo desenvolvimento educacional e pelas necessidades dos alunos, oferecemos planos de educação em IA para todas as séries do K-12.',
      imageAlt: 'Banner da solução educacional',
    },
    recommended: {
      title: 'Produtos recomendados',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Construa um espaço de ensino completo',
      tabs: {
        'teaching-assist': 'Assistência inteligente de ensino',
        'process-optimize': 'Otimização do fluxo de ensino',
        'device-manage': 'Gestão de equipamentos',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Assistência inteligente de ensino',
          features: [
            '·Monitoramento em tempo real e inventário de equipamentos e materiais',
            '·Assistente inteligente de ensino por IA',
            '·Painel visual',
          ],
        },
        'process-optimize': {
          title: 'Otimização do fluxo de ensino',
          features: [
            '·Distribuição e correção de tarefas online',
            '·Gestão remota centralizada de recursos do curso na nuvem',
          ],
        },
        'device-manage': {
          title: 'Gestão de equipamentos',
          features: [
            '·Monitoramento em tempo real de equipamentos educacionais',
            '·Solicitação remota de manutenção',
          ],
        },
      },
      categories: [
        {
          title: 'Distribuir e corrigir tarefas online',
          description:
            'Sistema inteligente de gestão de tarefas, aumentando a eficiência do ensino',
        },
        {
          title: 'Solicitação remota de manutenção',
          description:
            'Serviço conveniente de manutenção e solicitação de reparo remotos',
        },
        {
          title: 'Gestão remota centralizada, simplificando o fluxo de ensino',
          description:
            'Plataforma unificada de gestão remota, otimizando o fluxo de ensino',
        },
        {
          title: 'Recursos do curso na nuvem',
          description: 'Recursos e materiais didáticos ricos na nuvem',
        },
        {
          title: 'Monitoramento em tempo real de equipamentos educacionais',
          description:
            'Monitore o status dos equipamentos em tempo real para garantir o bom andamento do ensino',
        },
        {
          title: 'Assistente inteligente de ensino por IA',
          description:
            'Sistema de apoio ao ensino inteligente impulsionado por IA',
        },
      ],
      solutionCards: [
        { title: 'Solução de inovação com inteligência digital' },
        { title: 'Solução de sala de aula inteligente para ensino básico' },
        { title: 'Solução de competências para ensino técnico e profissional' },
        { title: 'Solução de sala de aula com IA para universidades' },
      ],
    },
    solutions: {
      title: 'Solução educacional integrada',
      items: [
        {
          title: 'Equipamentos',
          description:
            'No contexto de IA impulsionando a educação, os cortadores a laser Henghao, com suporte da plataforma inteligente em nuvem, integram-se profundamente à plataforma de ensino a laser da Zhongze Education. Os professores podem gerenciar equipamentos remotamente, distribuir tarefas e acompanhar o progresso dos alunos. Essa integração melhora a eficiência do ensino e oferece uma experiência de aprendizagem mais personalizada.',
          buttonText: 'Ver detalhes →',
        },
        {
          title: 'Software',
          description:
            'A plataforma Zhongze Education integra tecnologia de IA e oferece aprendizagem personalizada, ferramentas inteligentes, experiências interativas e recursos na nuvem. Suporta gestão de cursos e tarefas, monitoramento e alertas de equipamentos e análise de dados. Em conjunto com a Plataforma de Aprendizagem Zhongze Education (APP/PC) e o Light Maker, apoia o ensino de forma completa, otimiza recursos e impulsiona a inovação educacional, oferecendo suporte robusto a professores, alunos e instituições.',
          buttonText: 'Ver detalhes →',
        },
        {
          title: 'Cursos',
          description:
            'Os cursos de corte para inovação da Zhongze Education são programas sistemáticos e modulares, criados especialmente para jovens, para estimular interesses e potencial. Abrangem conhecimentos tecnológicos, pensamento inovador, prática de projetos e experimentos científicos, ajudando as crianças a se tornarem talentos de inovação do futuro e a promover o desenvolvimento social.',
          buttonText: 'Ver detalhes →',
        },
      ],
    },
    managementPlatform: {
      title: 'Plataforma de gestão de ensino inteligente Zhongze Education',
      desc: 'Oferece trilhas de aprendizagem personalizadas, ferramentas inteligentes de ensino, experiências interativas e biblioteca de recursos na nuvem. Suporta gestão de cursos, acompanhamento de progresso, tarefas online, monitoramento e alertas em tempo real de equipamentos educacionais e análise de dados. Com a integração de IA, melhora a eficácia do ensino e otimiza a alocação de recursos, fornecendo suporte educacional completo para alunos, professores, escolas e instituições, impulsionando o desenvolvimento e a inovação na educação.',
      items: [
        {
          title: 'Solução de inovação com inteligência digital',
          alt: 'Solução de inovação com inteligência digital',
        },
        {
          title: 'Solução de sala de aula inteligente para ensino básico',
          alt: 'Solução de sala de aula inteligente para ensino básico',
        },
        {
          title: 'Solução de competências para ensino técnico e profissional',
          alt: 'Solução de competências para ensino técnico e profissional',
        },
        {
          title: 'Solução de sala de aula com IA para universidades',
          alt: 'Solução de sala de aula com IA para universidades',
        },
      ],
      action: {
        text: 'Obter solução exclusiva',
        alt: 'Ícone de contato',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Maker Education — Ensino básico',
    },
    intro: {
      title: 'Cortadores a laser na educação e nas escolas',
      desc: 'Usar um cortador a laser na escola torna todo o processo — da ideia ao produto final — seguro, sem contato e digital. Transforme facilmente a imaginação das crianças em realidade.',
      imageAlt: 'Cortador a laser na produção de modelos arquitetônicos',
    },
    scenesFeatured: {
      title:
        'Use ferramentas educacionais de ponta para transformar a aprendizagem',
      desc: 'Ofereça aos alunos tecnologia líder do setor para aumentar criatividade, pensamento crítico e habilidades técnicas.',
    },
    scenes: {
      items: [
        {
          title: 'Uma plataforma de criação a laser para cada aluno',
          desc: 'Coloque a abordagem em prática e desenvolva a participação dos alunos, permitindo que usem ferramentas poderosas em sala para cultivar o pensamento criativo.',
        },
        {
          title: 'Kits de eletrônica e programação',
          desc: 'Com kits interativos, os alunos participam de programação prática, robótica e inteligência artificial.',
        },
        {
          title: 'Educação técnica e profissional',
          desc: 'Use uma plataforma de tecnologia a laser para construir trajetórias profissionais e elevar competências, adaptando-se a um mercado de trabalho em constante mudança e criando mais oportunidades.',
        },
      ],
    },
    solutions: {
      title: 'Os modelos arquitetônicos são amplamente usados em muitos campos',
      items: [
        { title: 'Escolas/distritos K-12' },
        { title: 'Instituições de treinamento' },
        { title: 'Laboratórios de pesquisa e cursos especializados' },
        { title: 'Espaços maker' },
        { title: 'Bibliotecas/museus de arquitetura' },
        { title: 'Cursos criativos' },
      ],
    },
    bannerLeft: {
      title: 'Levar a educação com IA para a prática',
      subtitle: 'IA + educação com inteligência digital, integrando a inovação',
    },
    products: {
      tabs: [
        {
          title: 'Equipamentos a laser',
          title1: 'Ferramenta essencial de criação - cortador a laser',
          description:
            'O Light 530 e o 640 reúnem componentes de primeira linha, processos de fabricação de alta qualidade e inspeção rigorosa, resultando em máquinas a laser potentes, de alto desempenho e estabilidade, com corte e gravação precisos. Atendem perfeitamente às necessidades de criação a laser em cenários de educação maker e inovação.',
        },
        {
          title: 'Software',
          title1: 'Especialista em desenho - LightMaker',
          description:
            'Oferece aos alunos segurança, velocidade, recursos inteligentes e uma experiência de design tecnológica inovadora. O LightMaker é compatível com diversos softwares, incluindo AI, PS, CorelDRAW, AutoCAD, Solidworks, e suporta o envio de arquivos de alta qualidade em JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, entre outros.',
        },
        {
          title: 'Cursos',
          title1: 'Ensino diversificado - cursos de educação de inovação',
          description:
            'Sabemos que cada criança é única; por isso, nossos cursos têm um design flexível e diversificado, com o objetivo de despertar o interesse e o potencial de cada aluno. O conteúdo inclui, entre outros: fundamentos de tecnologia, treinamento de pensamento inovador, projetos práticos e experimentos científicos.',
        },
      ],
    },
    learning: {
      title: 'Como usar o cortador a laser Zhongze Education nas aulas?',
      teacher: {
        title: 'Professor',
        lines: [
          'Produzir materiais didáticos e anexos para as aulas',
          'O cortador a laser ajuda o professor a produzir com eficiência materiais e acessórios para as aulas, além de permitir metodologias de ensino mais inovadoras.',
        ],
      },
      student: {
        title: 'Alunos',
        lines: [
          'Desenvolver habilidades práticas',
          'Em sala de aula, o cortador a laser acompanha os alunos na aprendizagem interdisciplinar — design, engenharia, tecnologia etc. — ajudando a transformar ideias em realidade.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Cenário de produção de modelos arquitetônicos 1' },
        { alt: 'Cenário de produção de modelos arquitetônicos 2' },
        { alt: 'Cenário de produção de modelos arquitetônicos 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Modelos arquitetônicos - Ensino técnico',
    },
    intro: {
      title:
        'Como usar o cortador a laser na produção de modelos arquitetônicos?',
      desc: 'Você pode usar o corte e a gravação a laser para produzir modelos arquitetônicos e também as menores peças de modelos da indústria de brinquedos. É possível cortar a laser, com rapidez e precisão, tecidos, plásticos, madeira, laminados, MDF, PMMA, papelão, papel, espuma, poliestireno, filmes, acrílico e muito mais.',
      imageAlt: 'Cortador a laser na produção de modelos arquitetônicos',
    },
    scenesFeatured: {
      title: 'A força que revoluciona a produção de modelos arquitetônicos',
      desc: 'Ajuda você a concluir amostras em miniatura detalhadas e modelos arquitetônicos de alta qualidade, apresentando com refinamento o seu projeto criativo.',
    },
    scenes: {
      items: [
        {
          title: 'Alta precisão',
          desc: 'O cortador a laser pode cortar materiais com altíssima precisão, mantendo o erro em uma faixa mínima, garantindo que cada peça do modelo tenha dimensões exatas e se encaixe perfeitamente nas exigências do projeto.',
        },
        {
          title: 'Materiais diversos',
          desc: 'A textura natural da madeira, a transparência e o brilho do acrílico e a leveza e maleabilidade do papel podem revelar um charme único com corte e gravação a laser.',
        },
        {
          title: 'Excelente capacidade para formas complexas',
          desc: 'Para formas geométricas complexas e detalhes finos comuns em modelos arquitetônicos, o corte a laser realiza com facilidade curvas, estruturas irregulares etc., oferecendo mais espaço criativo para a produção.',
        },
      ],
    },
    solutions: {
      title: 'Modelos arquitetônicos são amplamente usados em diversos campos',
      items: [
        { title: 'Educação e pesquisa acadêmica' },
        { title: 'Modelagem e indústria de brinquedos' },
        { title: 'Elementos decorativos e características arquitetônicas' },
        { title: 'Imobiliário e planejamento urbano' },
        { title: 'Decoração e reforma arquitetônica' },
      ],
    },
    bannerLeft: {
      title: 'Levar a educação com IA para a prática',
      subtitle: 'IA + educação com inteligência digital, integrando a inovação',
    },
    products: {
      tabs: [
        {
          title: 'Equipamento adequado',
          title1: 'Escolha o equipamento certo',
          description:
            'Os equipamentos a laser podem transformar rapidamente as ideias dos alunos em peças reais, seja para modelagem, design ou criação artística. De trabalhos manuais simples a projetos mecânicos complexos, cortadores e gravadores a laser executam com precisão, permitindo que os alunos aprendam e cresçam na prática.',
        },
        {
          title: 'Design próprio',
          title1: 'Crie o seu próprio design',
          description:
            'Edite o design de forma intuitiva e visualize o resultado final. Corte e reproduza detalhes de qualquer design em vários materiais: use texto, logotipos, imagens ou fotos para aprimorar o seu trabalho. Decore rapidamente os seus modelos arquitetônicos.',
        },
        {
          title: 'Seu mercado',
          title1: 'Eleve as habilidades dos alunos',
          description:
            'A marcadora a laser portátil é ideal para marcação e gravação de detalhes em modelos arquitetônicos. É simples de operar e fácil de transportar, sendo uma ferramenta essencial para o ensino de arquitetura.',
        },
      ],
    },
    learning: {
      title: 'Ensino interdisciplinar',
      groups: [
        {
          title: 'Modelos em miniatura',
          lines: [
            'Precisos e detalhados, atendendo às necessidades da criação em miniatura',
            'Apresente com refinamento detalhes de gravação/corte a laser em diversos materiais, eliminando etapas complexas, criando com eficiência e reduzindo erros manuais.',
          ],
        },
        {
          title: 'Design de interiores',
          lines: [
            'Detalhes do design prontos de primeira: a câmera integrada permite visualizar facilmente posição e tamanho do objeto; o que você vê é o que você obtém. Execute corte/gravação com eficiência e reduza o desperdício de material.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Cenário de produção de modelos arquitetônicos 1' },
        { alt: 'Cenário de produção de modelos arquitetônicos 2' },
        { alt: 'Cenário de produção de modelos arquitetônicos 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Artes e artesanato - Universidades',
    },
    intro: {
      title:
        'Como usar equipamentos a laser para processar obras de arte e artesanato',
      desc: 'Este equipamento oferece aos alunos uma plataforma para transformar criatividade em objetos reais, estimulando o pensamento inovador e a criatividade. Os alunos podem projetar modelos e obras únicas, como recortes a laser e carimbos.',
      imageAlt: 'Equipamentos a laser no processamento de artes e artesanato',
    },
    scenesFeatured: {
      title: 'Desenvolvimento de habilidades técnicas',
      desc: 'Ao operar o cortador/gravador a laser, os alunos adquirem conhecimentos aprofundados de ciência dos materiais e técnicas de processamento, melhorando a habilidade prática e a capacidade de resolver problemas.',
    },
    scenes: {
      items: [
        {
          title: 'Estímulo ao pensamento criativo',
          desc: 'O cortador/gravador a laser pode ser usado para materializar designs criativos dos alunos, como modelos e obras de arte, fortalecendo a criatividade.',
        },
        {
          title: 'Integração multidisciplinar',
          desc: 'A tecnologia de corte e gravação a laser envolve conhecimentos de várias áreas, como física, química, ciência dos materiais e ciência da computação. No ensino superior, pode promover a integração entre disciplinas e desenvolver competências abrangentes.',
        },
        {
          title: 'Projetos práticos de ensino',
          desc: 'A tecnologia de corte e gravação a laser pode ser aplicada em projetos práticos no ensino superior, como treinamento em engenharia, design artístico e criação cultural. Por exemplo, os alunos podem produzir modelos arquitetônicos, peças mecânicas e esculturas artísticas, integrando teoria e prática.',
        },
      ],
    },
    solutions: {
      title: 'Aplicações na produção de artesanato em universidades',
      items: [
        { title: 'Produtos de varejo personalizados' },
        { title: 'Presentes personalizados' },
        { title: 'Marketing sazonal' },
        { title: 'Acessórios de joalheria' },
        { title: 'Vestuário personalizado' },
      ],
    },
    bannerLeft: {
      title: 'Levar a educação com IA para a prática',
      subtitle: 'IA + educação com inteligência digital, integrando a inovação',
    },
    products: {
      tabs: [
        {
          title: 'Equipamento adequado',
          title1: 'Escolha o equipamento certo',
          description:
            'Ao escolher o equipamento de corte e gravação a laser adequado, universidades podem oferecer ferramentas avançadas para o ensino prático, estimular a criatividade e elevar a qualidade e a eficiência do ensino.',
        },
        {
          title: 'Design próprio',
          title1: 'Crie o seu próprio design',
          description:
            'Edite o design de forma intuitiva e visualize o resultado final. Grave e reproduza detalhes de qualquer design em diversos materiais: use texto, logotipos, imagens ou fotos para aprimorar o seu trabalho. O gravador a laser é muito simples de usar e permite decorar rapidamente as suas obras.',
        },
        {
          title: 'Artes e design',
          title1: 'Ensino em artes e design',
          description:
            'Em cursos como design artístico e design industrial, cortadores/gravadores a laser são amplamente usados em projetos de disciplinas e de conclusão. Os alunos podem transformar rapidamente ideias em protótipos físicos e desenvolver capacidade de criação de protótipos de produtos.',
        },
      ],
    },
    learning: {
      title: 'Leve o laser para a escola',
      groups: [
        {
          title: 'Preciso e eficiente, economiza tempo e esforço',
          lines: [
            'O cortador a laser da Zhongze suporta pré-visualização por câmera, alinhamento preciso sem desperdício; até iniciantes conseguem começar com facilidade.',
            'O uso é simples e fluido: basta colocar o material e criar; o que você vê é o que você obtém.',
            'Criação precisa: aproveite cada material, economizando tempo, esforço e material.',
          ],
        },
        {
          title: 'Alta potência, lida facilmente com diversos materiais',
          lines: [
            'Equipada com laser de CO₂ de alta potência, faz gravação e corte com excelência.',
            'Corta e grava facilmente acrílico, madeira, bambu e outros materiais, criando um fluxo amigável para entusiastas de artesanato e tornando a criação mais simples e eficiente.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Cenário de produção de artes e artesanato 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Design cultural e criativo - Ensino profissional superior',
    },
    intro: {
      title: 'Equipamentos a laser no design cultural e criativo',
      desc: 'Cursos de design cultural e criativo em instituições de ensino profissional superior geralmente contam com equipamentos avançados de corte e gravação a laser, como gravadores a laser, que atendem às necessidades de ensino prático em diferentes etapas.',
      imageAlt: 'Equipamentos a laser no design cultural e criativo',
    },
    scenesFeatured: {
      title: 'Desbloqueie infinitas possibilidades de criatividade e qualidade',
      desc: 'Com desempenho excepcional e capacidade de corte precisa, torna-se uma ferramenta indispensável para designers culturais e criativos.',
    },
    scenes: {
      items: [
        {
          title: 'Corte de alta precisão, detalhes perfeitos do design',
          desc: 'Para padrões complexos e formas únicas no design cultural e criativo, o cortador a laser reproduz com fidelidade, garantindo que cada detalhe apareça com precisão no produto final.',
        },
        {
          title: 'Processamento de diversos materiais',
          desc: 'Os equipamentos a laser podem processar vários materiais, como madeira, acrílico, couro e metal, oferecendo uma ampla seleção para o design de produtos culturais e criativos.',
        },
        {
          title:
            'Operação inteligente, simplificando a materialização da criatividade',
          desc: 'Os alunos só precisam importar o padrão desenhado no computador, e o cortador a laser identifica automaticamente e realiza o corte preciso. Essa operação inteligente reduz a exigência de habilidades especializadas e aumenta a estabilidade e a confiabilidade do processo.',
        },
      ],
    },
    solutions: {
      title: 'Leve mais bons designs para o dia a dia',
      items: [
        { title: 'Quadros decorativos com tema cultural' },
        { title: 'Design de luminárias criativas' },
        { title: 'Decoração e acessórios para casa' },
        { title: 'Porta-lápis e organizadores de papelaria' },
        { title: 'Acessórios de estilo étnico' },
        { title: 'Souvenirs turísticos' },
      ],
    },
    bannerLeft: {
      title: 'Levar a educação com IA para a prática',
      subtitle: 'IA + educação com inteligência digital, integrando a inovação',
    },
    learning: {
      title:
        'Ferramentas de produção no design cultural e criativo (ensino profissional superior)',
      groups: [
        {
          title: 'Personalização',
          lines: [
            'O cortador/gravador a laser permite personalizar facilmente fotos, nomes ou padrões especiais, atendendo à demanda por presentes únicos e memoráveis.',
            'Por exemplo, é possível gravar padrões ou textos escolhidos pelo consumidor em peças de madeira, acessórios de couro e itens decorativos de acrílico, tornando-os ainda mais personalizados.',
          ],
        },
        {
          title: 'Produção de produtos derivados culturais e criativos',
          lines: [
            'De souvenirs culturais de museus a produtos derivados de filmes e animações, o corte e a gravação a laser tornam designs complexos visuais e comercializáveis.',
            'Ele pode transformar pontos turísticos, edifícios icônicos e IPs culturais em produtos reais — por exemplo, cortar uma placa de madeira comum em uma peça decorativa com padrões e formas únicas, ou gravar uma folha de papel comum em uma obra artística refinada.',
          ],
        },
        {
          title: 'Criação DIY',
          lines: [
            'Equipamentos a laser ajudam entusiastas de artesanato a alcançar um nível mais alto de criação DIY, desde pequenas peças artesanais até decorações exclusivas para casa, tudo realizado rapidamente com tecnologia a laser.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Cenário de design cultural e criativo 1' },
        { alt: 'Cenário de design cultural e criativo 2' },
        { alt: 'Cenário de design cultural e criativo 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Cooperação educacional',
    },
    advantages: {
      title: 'Nossas vantagens de cooperação',
      items: [
        {
          title: 'Equipe de P&D experiente',
          desc: 'A Zhongze Education conta com uma equipe profissional formada por engenheiros e educadores de STEM, desenvolvendo continuamente produtos inovadores que atendem a altos padrões educacionais e engajam os alunos.',
        },
        {
          title: 'Capacitação digital inteligente de IA + educação',
          desc: 'Plataforma inteligente Zhongze Education: aprendizagem personalizada, ferramentas inteligentes e experiências interativas. Suporta gestão de cursos, acompanhamento de progresso, envio de tarefas, monitoramento de equipamentos e análise de dados; com recursos ricos na nuvem, o ensino se torna mais eficiente.',
        },
        {
          title: 'Sistema rico de kits e cursos',
          desc: 'Oferecemos cursos do nível iniciante ao avançado sobre corte a laser, casa inteligente, transporte inteligente etc., atendendo às necessidades de alunos de diferentes faixas etárias.',
        },
      ],
    },
    modes: {
      title: 'Modelos de cooperação',
      carouselAlts: [
        'Cenário de cooperação educacional',
        'Sala de aula de cooperação educacional',
        'Prática de cooperação educacional',
      ],
      items: [
        {
          title: 'Introdução de cursos',
          desc: 'As instituições parceiras podem adotar diretamente nosso sistema de cursos, elevando rapidamente a qualidade do ensino.',
        },
        {
          title: 'Kits',
          desc: 'Os kits são projetados para crianças de 3 a 16 anos. Com materiais experimentais seguros e fáceis de usar, despertam o interesse por ciência, tecnologia, engenharia, artes e matemática (STEAM).',
        },
        {
          title: 'Cooperação de produtos',
          desc: 'As instituições parceiras podem adquirir nossos produtos educacionais, como cortadores a laser, para ensino e prática dos alunos.',
        },
        {
          title: 'P&D conjunto',
          desc: 'Damos boas-vindas à participação de instituições parceiras no desenvolvimento de cursos e produtos, promovendo juntos a inovação educacional.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'Levar a educação com IA para a prática',
        'IA + educação com inteligência digital, integrando a inovação',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Centro de downloads',
      sectionTitle: 'Download de software',
      downloadButtonText: 'Baixar cliente',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'App da Plataforma de Aprendizagem Zhongze Education' },
        { name: 'Plataforma de Aprendizagem Zhongze Education' },
      ],
    },
    afterSales: {
      bannerTitle: 'Serviço pós-venda',
      serviceTitle: 'Serviço inteligente de AR',
      serviceItems: [
        {
          title: 'Diagnóstico remoto',
          desc: 'Orientação remota por AR: a equipe de suporte técnico visualiza o status do equipamento em tempo real, diagnostica falhas rapidamente e oferece recomendações precisas.',
        },
        {
          title: 'Reparo virtual',
          desc: 'Demonstração operacional por AR: apresenta virtualmente as etapas de manutenção, de forma clara e intuitiva, ajudando você a dominar o processo com facilidade.',
        },
        {
          title: 'Tutoriais inteligentes',
          desc: 'Aprendizagem interativa por AR: visualize o guia de operação diretamente no equipamento — eficiente e conveniente.',
        },
        {
          title: 'Resposta rápida',
          desc: 'Suporte imediato por AR: resposta rápida, menos espera e solução de problemas mais eficiente.',
        },
      ],
      videosTitle: 'Vídeos de operação',
      playButtonText: 'Reproduzir vídeo',
      videos: [
        { title: 'Demonstração de desembalagem' },
        { title: 'Como conectar a comunicação do equipamento' },
        { title: 'Tutorial de uso do Light 530' },
        { title: 'Tutorial de instalação após o unboxing' },
        { title: 'Operações básicas do software' },
        { title: 'Solução de problemas comuns' },
      ],
      manualsTitle: 'Manual de operação',
      viewPdfButtonText: 'Ver arquivo PDF',
      manuals: [
        { title: 'Manual de operação do Light 530' },
        { title: 'Manual de operação do Light 640' },
        { title: 'Manual do usuário do Blue 530' },
        { title: 'Guia de manutenção do M20' },
        { title: 'Manual de segurança para corte a laser' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Três séries principais de kits',
      bannerDesc:
        'Os kits suportam aprendizagem personalizada, adaptando-se a alunos de diferentes idades e necessidades. Ao mesmo tempo, oferecem aos professores recursos e ferramentas ricas, ajudando-os a ensinar e orientar de forma mais eficaz.',
      sections: {
        educationTitle: 'Kits educacionais',
        educationDesc: 'Cultivar pensamento inovador e criatividade',
        creativityTitle: 'Criatividade em ação, criar o futuro',
        projectsTitle: 'Projetos educacionais diversificados',
      },
      kitsTabs: [
        {
          name: 'Kit introdutório de corte a laser',
          title:
            'Kit introdutório de corte a laser\n(placas de madeira e consumíveis)',
          desc: 'Curso STEAM de corte a laser, baseado na teoria das inteligências múltiplas, nos conceitos de educação STEAM e na aprendizagem baseada em projetos (PBL). Voltado a alunos de diferentes idades, desenvolve capacidade de inovação, pensamento crítico, resolução de problemas e espírito de comunicação e colaboração em equipe.',
        },
        {
          name: 'Caixa mágica de ciência',
          title:
            'Caixa mágica de ciência\n(placas de madeira + kit de microcircuitos)',
          desc: 'O curso segue de perto as Diretrizes Curriculares de Ciências do Ensino Obrigatório (edição 2022). A partir de quatro dimensões — conceitos científicos, pensamento científico, investigação e prática, atitude e responsabilidade — desenvolve competências essenciais dos alunos. Cada aula conclui uma criação científica, abrangendo habilidades tradicionais, tecnologia/engenharia e sociedade, orientando os alunos a pensar como cientistas, aprimorar a capacidade investigativa e construir pensamento científico.',
        },
        {
          name: 'Kit de programação de IA',
          title: 'Kit de programação de IA',
          desc: 'Explore as tecnologias do futuro começando com o Kit de Programação de IA. Os kits de Fazenda Inteligente, Casa Inteligente, Transporte Inteligente e Fábrica Inteligente levam os alunos a conhecer tecnologia agrícola, vivenciar a vida moderna, explorar eficiência no transporte e compreender manufatura inteligente. A prática mão na massa desperta pensamento inovador e desenvolve resolução de problemas, preparando para o mundo inteligente.',
        },
      ],
      creativityItems: [
        {
          title: 'Reforçar habilidades práticas',
          desc: 'Esses kits integram educação STEMA (ciência, tecnologia, engenharia, artes e matemática). Por meio de atividades mão na massa e projetos práticos, elevam de forma abrangente a capacidade prática e a resolução de problemas dos alunos.',
        },
        {
          title: 'Cultivar pensamento inovador',
          desc: 'Incentiva os alunos a inovar em design e experimentos, desenvolvendo pensamento inovador e criatividade. Em projetos em equipe, aprimora comunicação e colaboração.',
        },
        {
          title: 'Apoio ao ensino do professor',
          desc: 'Oferece suporte para conduzir aulas e orientar projetos, ajudando a desenvolver inovação, colaboração e comunicação em equipe.',
        },
      ],
      projectItems: [
        { title: 'Ciência' },
        { title: 'Tecnologia' },
        { title: 'Programação' },
        { title: 'Artes' },
      ],
      bottomBannerText:
        'Por meio de atividades mão na massa e projetos práticos, os cursos fortalecem habilidades práticas e resolvem problemas reais; desenvolvem pensamento inovador e criatividade, incentivando design e experimentos. Projetos em equipe aprimoram comunicação e colaboração. O contato com tecnologias e ferramentas atuais ajuda os alunos a se adaptarem às demandas futuras da sociedade.',
    },
    courses: {
      bannerTitle: 'Sistema de cursos',
      bannerDesc:
        'Cursos STEAM sistematizados para diferentes faixas etárias, integrando ciência, tecnologia, engenharia, artes e matemática para formar talentos inovadores do futuro.',
      bannerAlt: 'Sistema de cursos',
      bottomBannerAlt: 'Demonstração do sistema de cursos',
      sections: {
        kitsTitle: 'Kits de curso',
        kitsDesc: 'Combinação perfeita de hardware e software',
        seriesTitle: 'Série de cursos premium',
      },
      courseTabs: [
        {
          name: 'Idade 3–6',
          title: 'Sistema de exploração científica – Infantil (6 aulas)',
          desc: 'A partir de fenômenos comuns do dia a dia e com materiais didáticos científicos, os alunos exploram mais a fundo para entender leis e princípios do desenvolvimento das coisas.',
        },
        {
          name: 'Idade 6–12',
          title: 'Sistema maker STEAM – Jovens (3 aulas)',
          desc: 'Estimula a criatividade, ensina a usar os equipamentos e, por meio da prática, transforma ideias em obras.',
        },
        {
          name: 'Idade 8–13',
          title: 'Sistema de cursos de corte a laser (3 aulas)',
          desc: 'Aprenda a cortar diferentes peças estruturais, montar estruturas tridimensionais e aperfeiçoar a estética. Programação: entender a lógica e os princípios das decisões na programação.',
        },
        {
          name: 'Idade 6–15',
          title: 'Sistema de cursos de inteligência artificial (4 aulas)',
          desc: 'Use ferramentas e equipamentos para projetar e produzir a aparência das criações e, com programação, torná-las inteligentes, simples e capazes de resolver problemas do cotidiano. Programação: entender a lógica e os princípios das decisões; aprender a sintaxe de programação do Arduino.',
        },
      ],
      introItems: [
        {
          title: 'Alta praticidade',
          desc: 'O curso prioriza a prática: os alunos operam equipamentos como cortadores a laser, convertendo teoria em habilidades aplicadas.',
        },
        {
          title: 'Desenvolvimento do pensamento inovador',
          desc: 'O curso incentiva design e produção criativos, desenvolvendo pensamento inovador e capacidade de resolver problemas.',
        },
        {
          title: 'Aprendizagem baseada em projetos',
          desc: 'O curso adota aprendizagem orientada por projetos; ao concluir tarefas concretas, os alunos aprendem e dominam conhecimentos na prática.',
        },
        {
          title: 'Exploração de tecnologias de ponta',
          desc: 'Com projetos como motor, os alunos praticam ao concluir tarefas específicas e consolidam o conhecimento.',
        },
        {
          title: 'Ensino sistematizado',
          desc: 'O curso avança do nível iniciante ao intermediário, ensinando corte a laser de forma estruturada e ajudando os alunos a construir uma base sólida.',
        },
        {
          title: 'Diversão e desafio',
          desc: 'O curso equilibra diversão e desafio, estimulando interesse e vontade de explorar.',
        },
      ],
      courseListRow1: [
        { name: 'Fazenda inteligente' },
        { name: 'Casa inteligente' },
      ],
      courseListRow2: [
        { name: 'Transporte inteligente' },
        { name: 'Fábrica inteligente' },
      ],
      bottomBannerText:
        'Com foco em prática, pensamento inovador e integração multidisciplinar, o curso adota aprendizagem baseada em projetos para que os alunos dominem tecnologias de ponta com diversão e desafios. Com ensino sistematizado, educação em segurança e aprendizagem personalizada, desenvolve habilidades práticas, espírito de equipe e resolução de problemas, incentivando a apresentação de resultados e reforçando a sensação de conquista.',
    },
    kitsAccessories: {
      bannerTitle: 'Acessórios do kit',
      accessories: [
        { name: 'Fita de LED RGB' },
        { name: 'Módulo de relógio DS1307' },
        { name: 'Sensor de temperatura e umidade DHT11' },
        { name: 'Sensor de presença (PIR)' },
        { name: 'Módulo de iluminação LED' },
        { name: 'Módulo de ventilador' },
        { name: 'Chave fotoelétrica tipo fenda' },
        { name: 'Módulo de botão' },
        { name: 'Placa de controle' },
        { name: 'Placa de expansão' },
        { name: 'Sensor de chuva' },
        { name: 'Motor TT com placa adaptadora' },
        { name: 'Módulo sensor infravermelho' },
        { name: 'Controle remoto infravermelho' },
        { name: 'Sensor de gás' },
        { name: 'Módulo display de 4 dígitos' },
        { name: 'Teclado matricial' },
        { name: 'Sensor de luminosidade' },
        { name: 'Módulo semáforo' },
        { name: 'Buzzer' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'Máquina inteligente de corte e gravação a laser de mesa',
      sections: {
        advantages: 'Nossas vantagens',
        aiTitle: 'Levar a educação com IA para a prática',
        aiSubtitle:
          'IA + educação com inteligência digital, integrando a inovação',
        carouselTitle: 'Possibilidades infinitas esculpidas com luz',
        specsTitle: 'Especificações do produto',
      },
      bannerFeatures: [
        'Captura pontual / traçado de gráficos / proteção de segurança',
        'Desenvolvido para educação STEAM e makers',
      ],
      softwareSection: {
        title: 'Sistema de corte a laser fácil de operar e poderoso',
        items: [
          'Permite definir parâmetros de processo conforme o material: corte, gravação profunda, gravação leve, varredura etc.',
          'Biblioteca rica de modelos e materiais, aumentando a eficiência de design.',
          'A câmera suporta captura pontual e auxilia no design, transformando criatividade em realidade.',
        ],
      },
      advantages: [
        {
          tagTitle: 'Laser de alta qualidade e alta precisão',
          desc: 'Por exemplo, tubo laser de CO₂ importado original, com comprimento de onda de 10640nm e potência contínua de 50W. A espessura máxima de corte pode chegar a 15mm (acrílico). A velocidade de trabalho atinge 1000mm/s, com precisão de repetibilidade de 0.025mm. Garante precisão e permite cortar e gravar rapidamente obras criativas refinadas.',
        },
        {
          tagTitle: 'Sistema integrado de filtragem tripla de gases',
          desc: 'Estrutura integrada com filtros, carvão ativado e camada UV/ozônio para múltiplas filtragens de fumaça e partículas. Além de ser mais limpo e ecológico, facilita uma instalação mais compacta, sem necessidade de comprar uma caixa de filtragem separada e ocupar mais espaço.',
        },
        {
          tagTitle: 'Proteção de segurança de prioridade máxima',
          desc: 'Aprovado nos mais altos testes de segurança do laboratório SGS; produto laser Classe I certificado pela FDA. Conta com um design exclusivo de proteção e indicadores de estado, permitindo acompanhar de forma clara e intuitiva o funcionamento da máquina.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          {
            label: 'Tipo de laser',
            value: 'Tubo laser de CO₂ de vidro selado',
          },
          { label: 'Curso de elevação da cabeça do laser', value: '≤25mm' },
          { label: 'Espessura máxima do material', value: '≤22mm' },
          { label: 'Modo de foco', value: 'Foco automático, foco manual' },
          { label: 'Conexão', value: 'Suporta conexão USB, LAN e Wi‑Fi' },
          { label: 'Sistemas operacionais suportados', value: 'Windows, iOS' },
          {
            label: 'Softwares de design suportados',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks etc.',
          },
          {
            label: 'Formatos de arquivo suportados',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG etc.',
          },
          { label: 'Vida útil do laser', value: '≤9000 horas' },
          {
            label: 'Software',
            value: 'LightMaker (PC e mobile), Lightburn (PC)',
          },
          {
            label: 'Forma de controle',
            value: 'Tela touch LCD de 5" / app móvel / software no PC',
          },
          { label: 'Ruído de operação', value: '≤60db' },
          {
            label: 'Transmissão',
            value:
              'Motor de passo de alta velocidade + guia linear de alta precisão + correia sincronizada',
          },
          {
            label: 'Proteção de segurança',
            value:
              'Chave de intertravamento: para ao abrir a tampa; para ao sofrer impacto; botão de emergência; chave de segurança; indicador de estado; alarme de alta temperatura do reservatório de água',
          },
          { label: 'Alimentação', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Peso da máquina', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Método de resfriamento',
            value: 'Sistema de resfriamento a água integrado (água ativa)',
          },
          {
            label: 'Tensão de trabalho',
            value: 'CC 24V, resfriamento a ar + serpentina de alumínio',
          },
          { label: 'Capacidade do reservatório', value: '3.2L' },
          { label: 'Altura máxima de bombeamento', value: '5M' },
          {
            label: 'Vazão de água',
            value:
              '1000L/H ou chiller a laser dedicado externo modelo CW3000 (opcional)',
          },
        ],
        airPumpSpecs: [
          { label: 'Vazão de ar', value: '50L/min' },
          { label: 'Ruído', value: '≤48dB' },
          { label: 'Pressão', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Potência nominal', value: '62W' },
          { label: 'Fluxo de ar', value: '280m³/H' },
          { label: 'Ruído', value: '≤50dB' },
          { label: 'Tensão', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle:
            'Parâmetros do sistema de resfriamento a água (integrado)',
          airPumpTitle: 'Parâmetros da bomba de ar (integrada)',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle:
            'Parâmetros do sistema de exaustão (externo integrado) com sucção lateral inferior',
          filterTitle: 'Sistema de filtragem',
          filterValue:
            'Algodão filtrante de carvão ativado + ventilador silencioso + placa de carvão ativado industrial',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'Máquina inteligente de corte e gravação a laser azul',
      sections: {
        advantages: 'Nossas vantagens',
        aiTitle: 'Levar a educação com IA para a prática',
        aiSubtitle:
          'IA + educação com inteligência digital, integrando a inovação',
        carouselTitle: 'Possibilidades infinitas esculpidas com luz',
        specsTitle: 'Especificações do produto',
      },
      bannerFeatures: [
        'Processa múltiplos materiais',
        'Crie com confiança, a qualquer hora com facilidade',
      ],
      advantages: [
        {
          tagTitle: 'Design e pegada',
          desc: 'O gravador a laser azul tem um design moderno, elegante e compacto, adequado para casa, escola ou estúdio. A combinação de corpo metálico com tampa de acrílico permite ver claramente o processo de trabalho no material.',
        },
        {
          tagTitle: 'Processamento fechado, evitando danos',
          desc: 'O gravador a laser azul é totalmente fechado. Se a tampa for aberta durante o trabalho, ele pausa automaticamente. Em caso de emergência, um único botão permite desligar a máquina imediatamente. Ideal para uso em casa e na escola.',
        },
        {
          tagTitle:
            'Processamento de múltiplos materiais, suporta centenas de materiais',
          desc: 'Personalize séries de produtos com formatos e estilos únicos. Adicione acessórios para gravar materiais em diferentes formas, como copos e objetos cilíndricos — ideal para necessidades de pequenos negócios.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Sistema de resfriamento',
          airPumpTitle: 'Parâmetros da bomba de ar',
          airPumpValueOnly: '—',
          exhaustTitle: 'Sistema de exaustão',
          filterTitle: 'Sistema de filtragem',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'Tipo de laser', value: 'Laser azul' },
          { key: 'laserPower', label: 'Potência do laser', value: '20W / 40W' },
          {
            key: 'maxCutThickness',
            label: 'Espessura máxima de corte',
            value: '≤10mm',
          },
          { key: 'focusMode', label: 'Modo de foco', value: 'Foco manual' },
          { key: 'connection', label: 'Conexão', value: 'Conexão USB' },
          {
            key: 'os',
            label: 'Sistemas operacionais suportados',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Software',
            value: 'LightBurn (PC)',
          },
          {
            key: 'laserLifetime',
            label: 'Vida útil do laser',
            value: '≥10000 horas',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Espessura máxima do material',
            value: '15mm',
          },
          { key: 'noise', label: 'Ruído de operação', value: '≤60dB' },
          {
            key: 'engraveSpeed',
            label: 'Velocidade de gravação',
            value: '600mm/s',
          },
          {
            key: 'designSoftware',
            label: 'Softwares de design suportados',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks etc.',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'maxSpeed',
            label: 'Velocidade máxima de trabalho',
            value: '1000mm/s',
          },
          {
            key: 'power',
            label: 'Alimentação',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Tamanho da mesa de trabalho',
            value: '520 × 315mm',
          },
          {
            key: 'accuracy',
            label: 'Precisão de posicionamento',
            value: '±0.01mm',
          },
          {
            key: 'repeatAccuracy',
            label: 'Precisão de repetibilidade',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Requisitos de energia',
            value: 'AC 220V ±10%, 50Hz',
          },
          { key: 'totalPower', label: 'Potência total', value: '300W' },
          {
            key: 'transmission',
            label: 'Transmissão',
            value:
              'Motor de passo de alta velocidade + guia linear de alta precisão + correia sincronizada',
          },
          {
            key: 'safety',
            label: 'Proteção de segurança',
            value:
              'Chave de trava: para ao abrir a tampa; limite por eixo elástico; botão de emergência; chave de segurança',
          },
          { key: 'weight', label: 'Peso da máquina', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Dimensões da máquina',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'Máquina de marcação a laser de alta precisão',
      sections: {
        advantages: 'Nossas vantagens',
        aiTitle: 'Levar a educação com IA para a prática',
        aiSubtitle:
          'IA + educação com inteligência digital, integrando a inovação',
        carouselTitle: 'Marcação a laser, personalização criativa',
        specsTitle: 'Especificações do produto',
      },
      bannerFeatures: [
        'Segurança garantida: controle por duplo interruptor e proteção a laser',
        'Gravação e corte com alta precisão, alta velocidade e alta estabilidade',
      ],
      advantages: [
        {
          tagTitle: 'Cenários de aplicação diversificados',
          desc: 'Este equipamento é adequado para diversos setores, incluindo gravação em joias, itens personalizados e identificação de peças. Atende a aplicações que vão de joias e frascos de perfume a pequenas placas industriais.',
        },
        {
          tagTitle: 'Aplicações inovadoras na educação',
          desc: 'O Mark M20 traz precisão de nível industrial para o ambiente educacional, tornando-se um “assistente versátil” para educação de inovação científica e tecnológica e desenvolvendo, nos alunos, desde habilidades básicas de marcação até a capacidade de realizar projetos complexos.',
        },
        {
          tagTitle: 'Compacta e moderna',
          desc: 'A máquina de marcação a laser Mark M20 tem design compacto e moderno, pequena área ocupada, baixo ruído e ampla janela de visualização, atendendo a requisitos de alta durabilidade. Seu visual elegante cumpre normas de segurança, sendo adequada para instituições educacionais e ambientes públicos de varejo.',
        },
        {
          tagTitle: 'Marcação concluída em segundos',
          desc: 'Mesmo com fontes muito pequenas, o Mark M20 conclui marcações precisas em poucos segundos. Essa velocidade incomparável, combinada ao fluxo de trabalho simplificado e eficiente do nosso software de aplicação a laser LightMaker, garante um aumento significativo de produtividade.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Tipo de laser', value: 'Laser de fibra' },
          {
            key: 'laserPower',
            label: 'Potência do laser',
            value: '20W / 30W / 50W',
          },
          {
            key: 'markArea',
            label: 'Área de marcação',
            value:
              'Padrão 110×110mm (pode ser expandido trocando diferentes lentes de campo, como 175×175mm etc.)',
          },
          {
            key: 'maxHeight',
            label: 'Altura máxima de trabalho',
            value: '≤130mm',
          },
          { key: 'connection', label: 'Conexão', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Sistemas operacionais suportados',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Alimentação',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Proteção de segurança',
            value:
              'Chave de trava: para ao abrir a tampa; limite por eixo elástico; botão de emergência; chave de segurança',
          },
          { key: 'software', label: 'Software suportado', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Transmissão',
            value:
              'Elevação do cabeçote de marcação por fuso elétrico de alta precisão',
          },
          {
            key: 'fileFormat',
            label: 'Arquivos suportados',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: 'Diâmetro do ponto focal', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'Máquina inteligente de corte e gravação a laser de bancada',
      sections: {
        advantages: 'Nossas vantagens',
        aiTitle: 'Levar a educação com IA para a prática',
        aiSubtitle:
          'IA + educação com inteligência digital, integrando a inovação',
        carouselTitle: 'Corte criativo começa aqui',
        specsTitle: 'Especificações do produto',
      },
      bannerFeatures: [
        'Rápido / Porta traseira aberta / Autofoco eficiente',
        'Gravador e cortador a laser tudo-em-um',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Área de trabalho',
          desc: 'Resultados excelentes de corte e gravação, com vários modelos e configurações de potência para atender a diferentes aplicações\nTipo de laser: CO₂ DC\nPotência do laser: 60W–130W\nLight640 (600*400mm)\nLight960 (900*600mm)\nLight1390 (1300*900mm)\nLight1610 (1600*1000mm)',
        },
        {
          tagTitle: 'Autofoco eficiente + posicionamento por ponto vermelho',
          desc: 'O autofoco realiza foco e posicionamento rápidos e precisos antes de cortar e gravar. Com o feixe de ponto vermelho, é possível visualizar a posição de trabalho em tempo real. Assim, você economiza muito tempo e obtém melhores resultados de corte e gravação.',
        },
        {
          tagTitle: 'Design de porta traseira aberta',
          desc: 'A porta traseira aberta permite inserir materiais de corte e gravação com comprimento ilimitado. Placas de 600mm×∞ tornam o trabalho mais conveniente e com menos limitações.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Resultados excelentes de corte e gravação',
            desc: 'O cortador a laser utiliza uma plataforma de corte de alta precisão. O processamento de materiais como madeira e acrílico atinge padrões e eficiência de nível empresarial, permitindo produção em escala de produtos artesanais a laser e impulsionando produtividade e impacto da marca.',
          },
          {
            tagTitle: 'Tubo laser de qualidade e componentes de precisão',
            desc: 'Linha diversificada: escolha diferentes tipos de laser e intensidades de processamento conforme a necessidade, atendendo a vários requisitos de produção e ampliando aplicações em madeira, vidro, acrílico e outros materiais e processos.',
          },
          {
            tagTitle: 'Testes rigorosos de qualidade, garantia de excelência',
            desc: 'Testes rigorosos na linha de produção, controle óptico preciso e mais de 5 testes de corte e gravação garantem um tubo laser de CO₂ de alto nível com saída estável e consistente. Com excelente estabilidade de potência e ponto de laser fino, é possível gravar de forma uniforme e até reproduzir detalhes complexos.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Resultados excelentes de corte e gravação',
            desc: 'O cortador a laser utiliza uma plataforma de corte de alta precisão. O processamento de materiais como madeira e acrílico atinge padrões e eficiência de nível empresarial, permitindo produção em escala de produtos artesanais a laser e impulsionando produtividade e impacto da marca.',
          },
          {
            tagTitle: 'Tubo laser de qualidade e componentes de precisão',
            desc: 'Linha diversificada: escolha diferentes tipos de laser e intensidades de processamento conforme a necessidade, atendendo a vários requisitos de produção e ampliando aplicações em madeira, vidro, acrílico e outros materiais e processos.',
          },
          {
            tagTitle: 'Testes rigorosos de qualidade, garantia de excelência',
            desc: 'Testes rigorosos na linha de produção, controle óptico preciso e mais de 5 testes de corte e gravação garantem um tubo laser de CO₂ de alto nível com saída estável e consistente. Com excelente estabilidade de potência e ponto de laser fino, é possível gravar de forma uniforme e até reproduzir detalhes complexos.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Recursos de segurança completos e avançados',
            desc: '1. Parada de emergência\n2. Luz de alarme\n3. Chave à prova d’água\n4. Fio de aterramento\n5. Alarme do detector térmico integrado é acionado automaticamente em atividades anormais\n6. Proteção de trava da tampa\n7. Janela de proteção durável em vidro temperado',
          },
          {
            tagTitle: 'Durável e de qualidade excepcional',
            desc: '1. Ideal para projetos unitários ou produção em grande escala.\n2. Ampla faixa de áreas de trabalho, de 600 x 400MM a 1600 x 1000MM.\n3. Velocidade de gravação incomparável.\n4. Projetado por especialistas do setor.\n5. Escolha ideal para aplicações personalizadas, educacionais e industriais.',
          },
          {
            tagTitle: 'Otimize a produção com monitoramento inteligente',
            desc: 'Projetado para proteger os componentes mais caros (eixos, cabeçote a laser, elementos ópticos e lentes) contra poeira e sujeira, garantindo anos de operação sem falhas mesmo sob uso intenso.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'O que o Light 640 pode fazer',
          items: [
            {
              title: 'Light 640 - Projeto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Projeto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Projeto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Projeto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Projeto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Projeto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Projeto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Projeto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'O que o Light 960 pode fazer',
          items: [
            {
              title: 'Light 960 - Projeto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Projeto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Projeto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Projeto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Projeto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Projeto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Projeto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Projeto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'O que o Light 1390 pode fazer',
          items: [
            {
              title: 'Light 1390 - Projeto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Projeto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Projeto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Projeto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Projeto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Projeto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Projeto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Projeto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'O que o Light 1610 pode fazer',
          items: [
            {
              title: 'Light 1610 - Projeto 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Projeto 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Projeto 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Projeto 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Projeto 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Projeto 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Projeto 7',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Projeto 8',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Sistema de refrigeração',

          exhaustTitle: 'Sistema de exaustão',
        },
        left: [
          { key: 'model', label: 'Modelo do equipamento', value: 'Light 640' },
          {
            key: 'workArea',
            label: 'Área de trabalho',
            value: '600mm × 400mm',
          },
          {
            key: 'laserType',
            label: 'Tipo de laser',
            value: 'Tubo laser de vidro CO₂ selado',
          },
          {
            key: 'laserPower',
            label: 'Potência do laser',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Altura do eixo Z',
            value: '135mm (5.3″)',
          },
          {
            key: 'tableSize',
            label: 'Tamanho da mesa',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label:
              'Tamanho máximo do material (portas frontal e traseira fechadas)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Tamanho máximo do material (porta traseira aberta)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'Tamanho da máquina (L × C × A)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'Peso da máquina',
            value: '300kg (660 lb)',
          },
          {
            key: 'maxSpeed',
            label: 'Velocidade máxima de trabalho',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Precisão de posicionamento',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Modo de foco',
            value: 'Foco automático / foco manual',
          },
          {
            key: 'resume',
            label: 'Retomar gravação após falha de energia',
            value: 'Suportado',
          },
          {
            key: 'transmission',
            label: 'Transmissão',
            value:
              'Motor de passo de alta velocidade + motor de malha fechada de alta precisão',
          },
          {
            key: 'connection',
            label: 'Conectividade',
            value: 'LAN / USB / Wi‑Fi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Software',
            value: 'Good-Laser LightMaker (compatível com LightBurn)',
          },
          {
            key: 'process',
            label: 'Processo',
            value: 'Traço linear, corte, gravação profunda, gravação leve',
          },
          {
            key: 'fileFormats',
            label: 'Formatos de ficheiro suportados',
            value: 'Bitmap: JPG / PNG / BMP; Vetor: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Frequência',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Fase',
            value: 'Monofásico',
          },
          {
            key: 'current',
            label: 'Corrente em carga total',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Tensão',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: 'Potência total',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Materiais aplicáveis',
            value:
              'Madeira, acrílico, couro, tecido, plástico, papelão, borracha, placa bicolor, mármore, vidro, alumínio anodizado e outros materiais não metálicos',
          },
          {
            key: 'safety',
            label: 'Normas de segurança',
            value:
              'Em conformidade com as normas de segurança CE da UE, com proteção de abertura da tampa da câmara de trabalho, sistema de proteção de refrigeração, sistema de alarme automático de controlo de temperatura, proteção contra fuga de corrente, proteção de paragem de emergência, sistema de percurso óptico, sistema de observação com vidro temperado, indicadores de estado de funcionamento, etc.',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Modo de refrigeração',
            value: 'Refrigeração a água',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Diâmetro da saída de exaustão',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Tubo laser de vidro CO₂ selado',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm (5.3″)',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg (902 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Foco automático / foco manual',
          resume: 'Suportado',
          transmission:
            'Motor de passo de alta velocidade + motor de malha fechada de alta precisão',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatível com LightBurn)',
          process: 'Traço linear, corte, gravação profunda, gravação leve',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vetor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Madeira, acrílico, couro, tecido, plástico, papelão, borracha, placa bicolor, mármore, vidro, alumínio anodizado e outros materiais não metálicos',
          safety:
            'Em conformidade com as normas de segurança CE da UE, com proteção de abertura da tampa da câmara de trabalho, sistema de proteção de refrigeração a água, sistema de alarme automático de controlo de temperatura, proteção contra fuga de corrente, proteção de paragem de emergência, sistema de percurso óptico, sistema de observação com vidro temperado, indicadores de estado de funcionamento, etc.',
          coolingMode: 'Refrigeração a água',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Tubo laser de vidro CO₂ selado',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm (5.3″)',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg (1100 lb)',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Foco automático / foco manual',
          resume: 'Suportado',
          transmission:
            'Motor de passo de alta velocidade + motor de malha fechada de alta precisão',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatível com LightBurn)',
          process: 'Traço linear, corte, gravação profunda, gravação leve',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vetor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Madeira, acrílico, couro, tecido, plástico, papelão, borracha, placa bicolor, mármore, vidro, alumínio anodizado e outros materiais não metálicos',
          safety:
            'Em conformidade com as normas de segurança CE da UE, com proteção de abertura da tampa da câmara de trabalho, sistema de proteção de refrigeração a água, sistema de alarme automático de controlo de temperatura, proteção contra fuga de corrente, proteção de paragem de emergência, sistema de percurso óptico, sistema de observação com vidro temperado, indicadores de estado de funcionamento, etc.',
          coolingMode: 'Refrigeração a água',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Tubo laser de vidro CO₂ selado',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm (5.3″)',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg (1298 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Foco automático / foco manual',
          resume: 'Suportado',
          transmission:
            'Motor de passo de alta velocidade + motor de malha fechada de alta precisão',
          connection: 'LAN / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatível com LightBurn)',
          process: 'Traço linear, corte, gravação profunda, gravação leve',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vetor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Madeira, acrílico, couro, tecido, plástico, papelão, borracha, placa bicolor, mármore, vidro, alumínio anodizado e outros materiais não metálicos',
          safety:
            'Totalmente em conformidade com as normas de segurança CE da UE, com proteção de abertura da tampa, proteção de refrigeração a água, alarme de temperatura, proteção contra fuga de corrente, paragem de emergência e sistema de circuito fechado do laser',
          coolingMode: 'Refrigeração a água',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Seu endereço de e-mail',
      button: 'Subscrever',
    },
    social: {
      tiktok: 'TikTok',
      weibo: 'Canais do WeChat',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu',
    },
    companyDesc:
      'Focamos na educação de criatividade tecnológica para crianças e adolescentes de 3 a 16 anos. Operamos espaços de educação maker e desenvolvemos de forma independente produtos e cursos educacionais, abrangendo módulos como software de design de aprendizagem, gravação a laser, programação e outros.',
    navColumns: [
      {
        title: 'Produtos',
        items: [
          { label: 'Equipamentos', to: '/product/light530' },
          { label: 'Kits', to: '/product/kits' },
          { label: 'Cursos', to: '/product/courses' },
        ],
      },
      {
        title: 'Software',
        items: [
          {
            label: 'Plataforma em Nuvem Zhongze Education',
            to: '/software/cloud-platform',
          },
          {
            label: 'Plataforma de Aprendizagem Zhongze Education',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Serviços educacionais',
        items: [
          { label: 'Soluções de educação com IA', to: '/edu-services' },
          {
            label: 'Maker Education — Ensino básico',
            to: '/edu-services/maker-k12',
          },
          {
            label: 'Modelos arquitetônicos — Ensino técnico',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Design cultural e criativo — Ensino profissional superior',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Artes e artesanato — Universidades',
            to: '/edu-services/arts-university',
          },
          { label: 'Espaço maker', to: '/edu-services' },
        ],
      },
      {
        title: 'Serviço e suporte',
        items: [
          { label: 'Centro de downloads', to: '/support/download' },
          { label: 'Pós-venda', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Cooperação educacional',
        items: [
          { label: 'Cooperação educacional', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'Sobre nós',
        items: [
          { label: 'Sobre nós', to: '/about' },
          { label: 'Notícias', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Linha de vendas: 18379276683',
      email: 'E-mail: sam@zz-steam.com',
      address:
        'Endereço: Edifício Huashengda, Torre A, Bagua 4ª Rua, Futian, Shenzhen',
    },
    qrDesc: 'Saiba mais',
  },

  globalContactForm: {
    title: 'Fale conosco',
    subtitle:
      'Preencha o formulário abaixo e entraremos em contacto o mais breve possível',
    fields: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      company: 'Empresa',
      message: 'Mensagem',
    },
    placeholders: {
      name: 'Insira o seu nome',
      email: 'Insira o seu e-mail',
      phone: 'Insira o seu telefone',
      company: 'Insira o nome da sua empresa',
      message: 'Insira a sua mensagem',
    },
    submitting: 'A enviar...',
    submit: 'Enviar',
    visual: {
      title: 'Ansiosos por colaborar consigo',
      description:
        'Oferecemos serviços e suporte profissionais. Se tiver alguma dúvida, contacte-nos a qualquer momento.',
    },
    contact: {
      phone: 'Telefone de contacto',
      email: 'E-mail de contacto',
    },
    validation: {
      name: 'Insira o seu nome',
      email: 'Insira o seu e-mail',
      emailFormat: 'Insira um e-mail válido',
      phone: 'Insira o seu número de telefone',
      phoneFormat: 'Insira um número de telefone válido',
      message: 'Insira a sua mensagem',
    },
    success: 'Enviado com sucesso! Entraremos em contacto em breve.',
    networkError: 'Falha ao enviar. Tente novamente mais tarde.',
  },
};
